/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { getCapabilities as getInitialCapabilities } from '@nextcloud/capabilities';
var initialCapabilities = getInitialCapabilities();
var CapabilitiesService = /** @class */ (function () {
    function CapabilitiesService() {
        this.capabilities = initialCapabilities.richdocuments;
    }
    CapabilitiesService.prototype.getCapabilities = function () {
        return this.capabilities;
    };
    CapabilitiesService.prototype.setCapabilities = function (capabilities) {
        this.capabilities = capabilities;
    };
    CapabilitiesService.prototype.updateCapability = function (key, value) {
        this.capabilities[key] = value;
    };
    return CapabilitiesService;
}());
var capabilitiesService = new CapabilitiesService();
var getCapabilities = function () {
    return capabilitiesService.getCapabilities();
};
export { getCapabilities, capabilitiesService };
